<template>
  <!-- This is the html-esque code used to define the layout. Note the syntax difference in assigning variable attributes -->
  <div class="c-header--wrapper">
    <div class="c-header--primary">
        <div class="row">
          <div class="col-sm-12">
            <div class="c-header__menu-nav" id="c-menu">
                <a class="icon" style="padding: 10px;" @click="openbar()">
                  <i class="fa fa-bars" style="color:#777777"></i>
                </a>
                <a href="https://www.sequis.co.id/" >
                  <img alt="Sequis logo" src="../../../assets/images/svg/logo-sequis.svg" target="_blank" height="40" style="margin-right:30px; padding-left: 25px;">
                </a>
                <div class="c-header__menu-center">
                    <ul class="c-header__menu-group mb-0">
                        <li
                          v-for="(link, key) in links"
                          :key="key"
                          class="c-header__menu-group-list">
                            <a :href="link.path" target="_blank">
                                <span class="mr-5 icon-header">
                                     {{ link.text }}
                                </span>
                                <span class="u-v-middle"></span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="icon-sosmed">
                  <ul class="mb-0">
                      <li
                        v-for="(item, key) in sosmeds"
                        :key="key"
                        class="c-header__menu-group-list">
                        <a :href="item.url" target="_blank">
                          <img :src="item.imageUrl" height="20">
                        </a>
                      </li>
                  </ul>
                </div>
            </div>
          </div>
        </div>
        <div class="row" >
          
          <div class="topnav" id="myTopnav" >
            <a 
              v-for="(link, key) in links"
              :key="key"
              :href="link.path"
              target="_blank"
            >
              {{ link.text }}
            </a>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Navigation',
    data: function () {
      return {
        links:  [
          { path: 'https://www.sequis.co.id/id/tentang-sequis/life/profil-perusahaan', text: 'Tentang' },
          { path: 'https://www.sequis.co.id/id/contact-us', text: 'Hubungi kami' },
          { path: 'https://www.sequis.co.id/', text: 'Sequis.co.id' },
          { path: '/privacy-policy', text: 'Kebijakan Privasi' }
        ],
        sosmeds: [
          { imageUrl: require('../../../assets/images/svg/twitter.svg'), url: ' https://twitter.com/SequisOFFICIAL' },
          { imageUrl:  require('../../../assets/images/svg/facebook.svg'), url: 'https://www.facebook.com/sequislife/' },
          { imageUrl:  require('../../../assets/images/svg/instagram.svg'), url: ' https://www.instagram.com/sequisofficial/' },
          { imageUrl:  require('../../../assets/images/svg/youtube.svg'), url: 'https://www.youtube.com/ajsequislife' }
        ]
      }
    },
    methods: {
      openbar() {
        let x = document.getElementById("myTopnav");
        if (x.className === "topnav") {
          x.className += " responsive";
        } else {
          x.className = "topnav";
        }
      },
    },
  }
</script>